<template>
  <div v-if="hasNotifications" class="notifications">
    <div class="container">
      <div class="notification" :class="{'is-primary': !notification.error, 'is-danger': notification.error}" v-for="notification in notifications" :key="notification.key" @click="action(notification)">
        <button class="delete" @click.stop="dismiss(notification)"></button>
        <div v-if="notification.title" v-html="notification.title" class="notification-title"></div>
        <div v-html="notification.message" class="notification-message"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    hasNotifications: function () {
      return this.notifications.length > 0
    },
    notifications: function () {
      return this.$store.getters.notifications
    }
  },

  methods: {
    action: function (notification) {
      if (notification.key === 'version') {
        location.reload()
      }

      if (notification.deepLink) {
        this.$router.push({ path: notification.deepLink })
      }

      this.dismiss(notification)
    },
    dismiss: function (notification) {
      this.$store.dispatch('deleteNotification', notification.key)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .notifications {
    position: fixed;
    z-index: 100;
    margin: auto;
    width: 100%;
    padding-top: 1rem;

    @include mobile {
      padding-top: 3rem;
    }

    .notification {
      cursor: pointer;
      box-shadow: $default-shadow;

      @include mobile {
        margin: 0.5rem;
      }

      .notification-title {
        font-weight: bold;
      }

      .notification-message {}
    }
  }
</style>
